import Head from "next/head";
import { NextPage } from "next";

const SorteioDeNomes: NextPage = () => {
  return (
    <>
      <Head>
        <title>Sorteio no Instagram - InstaSorteio</title>
      </Head>
      <iframe
        src="https://lp-instasorteio.vercel.app/sorteio-de-nomes"
        width="100%"
        height="950"
        style={{ border: "0", overflow: "hidden", height: "100vh" }}
        allowFullScreen
      />
    </>
  );
};

export default SorteioDeNomes;
